module.exports = __webpack_public_path__ + "static/img/3.da0142e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/questionnaire/3.png
// module id = tdHY
// module chunks = 1